"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var JsSearch = require("js-search");

var reset = function reset(_ref) {
  var documents = _ref.documents,
      indices = _ref.indices,
      indexer = _ref.indexer,
      term = _ref.term,
      _ref$searchSubstring = _ref.searchSubstring,
      searchSubstring = _ref$searchSubstring === void 0 ? false : _ref$searchSubstring;
  var searcher = new JsSearch.Search(indexer);

  if (searchSubstring) {
    searcher.indexStrategy = new JsSearch.AllSubstringsIndexStrategy();
  }

  indices.forEach(function (index) {
    searcher.addIndex(index);
  });

  if (documents && documents.length) {
    searcher.addDocuments(documents);
  } else {
    console.warn("[SEARCH]: No documents provided. This will cause search to fail");
  }

  var result = documents;

  if (term) {
    result = searcher.search(term);
  }

  return {
    result: result,
    documents: documents,
    searcher: searcher,
    term: term
  };
};

var Search =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search(props, context) {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).call(this, props, context));
    _this.handleSearch = _this.handleSearch.bind(_assertThisInitialized(_this));
    _this.state = _objectSpread2({}, reset(props), {
      search: _this.handleSearch
    });
    return _this;
  }

  _createClass(Search, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.documents !== prevProps.documents) {
        var newState = _objectSpread2({}, reset(this.props), {
          term: this.state.term // eslint-disable-next-line react/no-did-update-set-state

        });

        this.setState(newState);
      }
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(term) {
      if (!term) {
        this.setState({
          result: this.props.documents,
          term: null
        });
        return;
      }

      var result = this.state.searcher.search(term);
      this.setState({
        result: result,
        term: term
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(_objectSpread2({}, this.state));
    }
  }]);

  return Search;
}(_react["default"].Component);

Search.propTypes = {
  children: _propTypes["default"].func,
  documents: _propTypes["default"].array.isRequired,
  indexer: _propTypes["default"].string,
  indices: _propTypes["default"].array.isRequired
};
var _default = Search;
exports["default"] = _default;
Search.defaultProps = {};